export default "__VITE_ASSET__Br1SIXJM__"